package org.zest.insan_360_website.data

import org.zest.insan_360_website.components.widgets.Measurements

val GRAPH_MEASUREMENT = Measurements(
    width = 80,
    height = 192,
    typeHeight = 10,
    labelHeight = 9,
    percentHeight = 9,
    horizontalGap = 4,
    verticalGap = 4,
)